import { isNative } from "@/lib/native";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Share, X, Download } from "lucide-react";

export default function PwaBanner() {
  const [show, setShow] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const dismissed = localStorage.getItem("astra_pwa_dismissed");
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (!dismissed && !standalone && !isNative) {
      const visits = Number(localStorage.getItem("astra_visits") || 0) + 1;
      localStorage.setItem("astra_visits", String(visits));
      if (visits < 2) return;
      const t = setTimeout(() => setShow(true), 15000);
      return () => clearTimeout(t);
    }
  }, []);

  // Only surface the install prompt on the Today screen so it never covers
  // controls on other pages (e.g. the delete/privacy buttons on Profile).
  if (!show || location.pathname !== "/today") return null;

  const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed bottom-[calc(5rem+env(safe-area-inset-bottom))] left-3 right-3 max-w-[22rem] mx-auto z-40 bg-[#0B0F19] border border-[#D4AF37]/30 rounded-2xl p-4 fade-up shadow-2xl"
    >
      <button
        data-testid="btn-pwa-dismiss"
        onClick={() => {
          localStorage.setItem("astra_pwa_dismissed", "1");
          setShow(false);
        }}
        className="absolute top-3 right-3 text-[#A7B0C0]"
      >
        <X size={18} />
      </button>
      <div className="flex items-center gap-2 mb-1">
        <Download size={16} className="gold-text" />
        <p className="font-medium text-base">Install Astra</p>
      </div>
      {isIos ? (
        <p className="text-sm text-[#A7B0C0] flex items-center gap-1 flex-wrap">
          Tap <Share size={14} className="inline gold-text" /> then
          <span className="gold-text"> Add to Home Screen</span> for daily readings offline.
        </p>
      ) : (
        <p className="text-sm text-[#A7B0C0]">
          Open your browser menu and tap <span className="gold-text">Install App</span> for offline daily readings.
        </p>
      )}
    </div>
  );
}
